import React from 'react';
import { Card, Table, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ownerIntelligenceService from '@/services/ownerIntelligence.service';
import { OiPageFrame } from '@/components/owner-intelligence/OwnerIntelligenceComponents';

const StrategyAlignmentPage: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ['owner-intelligence', 'strategy-alignment'],
    queryFn: () => ownerIntelligenceService.getStrategyAlignment(),
  });

  const payload = data as { objectives?: Record<string, unknown>[] };

  return (
    <OiPageFrame
      subtitle="Strategic objectives linked to KPIs — full KPI catalog and targets are on KPI Performance."
      loading={isLoading && !data}
      error={Boolean(error)}
      errorMessage="Strategy alignment unavailable"
    >
      <Card title="Strategic objectives" bordered={false}>
        <Table
          size="small"
          rowKey="id"
          dataSource={payload?.objectives ?? []}
          locale={{ emptyText: 'No objectives defined — seed via platform admin or migration.' }}
          columns={[
            { title: 'Objective', dataIndex: 'title' },
            { title: 'Owner', dataIndex: 'owner_role' },
            { title: 'Horizon', dataIndex: 'time_horizon' },
            {
              title: 'Linked KPIs',
              dataIndex: 'linked_kpi_codes',
              render: (codes: string[]) =>
                (codes ?? []).map((c) => (
                  <Button key={c} type="link" size="small" style={{ padding: 0, marginRight: 8 }} onClick={() => navigate(`/owner-intelligence/kpis?code=${c}`)}>
                    {c}
                  </Button>
                )),
            },
          ]}
        />
      </Card>
      <p className="oi-subtitle" style={{ marginTop: 16 }}>
        <Button type="link" style={{ padding: 0 }} onClick={() => navigate('/owner-intelligence/kpis')}>
          Open KPI Performance →
        </Button>
      </p>
    </OiPageFrame>
  );
};

export default StrategyAlignmentPage;
